import React from 'react';
// Constants
import {
  CONTACT_PAGE_URL,
  SESSIONS_PAGE_URL,
  ABOUT_PAGE_URL,
  FANSITES_PAGE_URL,
} from '../../utils/constants/Routes';
import {
  CompanyName,
} from '../../utils/constants/Constants';

function CallToActionOne() {
  const buttons = [
    {
      text: 'Meet Me',
      link: ABOUT_PAGE_URL,
      ariaLabel: `Send a tribute to ${CompanyName}`,
    },
    {
      text: 'Book Now',
      link: CONTACT_PAGE_URL,
      ariaLabel: `Book a session with ${CompanyName}`,
    },
    {
      text: 'Sessions',
      link: SESSIONS_PAGE_URL,
      ariaLabel: `View Queen Blaire's offerings`,
    },
    {
      text: 'Fansites',
      link: FANSITES_PAGE_URL,
      ariaLabel: `Explore Queen Blaire's online presence`,
    },
  ];

  return (
    <section className='grid justify-center h-fit md:grid-flow-col mx-auto py-4 gap-x-6 gap-y-4 md:w-fit'>
      {buttons.map((btn, index) => (
        <a
          key={index}
          href={btn.link}
          className={`cursor-pointer hover:bg-colour8 border-4 shadow-cardShadow border-solid border-colour8 bg-black w-full text-center h-fit px-10 md:px-2 lg:px-12 py-2 mx-auto`}
          aria-label={btn.ariaLabel}
        >
          {btn.text}
        </a>
      ))}
    </section>
  );
}

export default CallToActionOne;
